import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';
import {InputSelect} from '@emersya/mpa-components';

export interface ILanguageSelectorComponentConfiguration extends CM.DOMComponent.IConfiguration {
	translations: Record<string, STD.translationsManager.TranslationMapping>;
};

export class LanguageSelectorComponent extends CM.DOMComponent<
	HTMLDivElement,
	LanguageSelectorComponent,
	ILanguageSelectorComponentConfiguration
> {

	component_DOM: HTMLDivElement;

	static override initialize() {
		super.initialize();
	};

	override async component_initialize() {
		const inputSelect = await this.component_instantiateOuterChild({
			type: 'input-select',
			isSlot: false,
			id: 'options',
			slot: null,
			tree: this.component_tree,
			parentNode: null,
			configuration: <InputSelect.Configuration>{
				defaultValue: app.currentLanguage
			}
		});
		for (const lang of app.component_configuration.languages.list) {
			const trIcon = STD.translationsManager.languages.reduce<Record<string, string>>((a, c) => {
				a[c] = 'icon' + lang.name;
				return a;
			}, {});
			const inputButton = await inputSelect.component_instantiateOuterChild({
				type: 'input-button',
				isSlot: false,
				id: lang.id,
				slot: null,
				tree: this.component_tree,
				parentNode: null,
				configuration: {}
			});
			const text = await inputButton.component_instantiateOuterChild({
				type: 'text',
				isSlot: false,
				id: 'country',
				slot: null,
				tree: this.component_tree,
				parentNode: null,
				configuration: {
					'@translations': {
						text: <STD.translationsManager.TranslationMapping>this.component_configuration.translations[lang.id]
					}
				}
			});
			const image = await inputButton.component_instantiateOuterChild({
				type: 'image',
				isSlot: false,
				id: 'icon',
				slot: null,
				tree: this.component_tree,
				parentNode: null,
				configuration: {
					'URL': `${app.clientAppParameters.app.assetsPath}icon-flag-${lang.id}.png`.replace(
						'XUJG0A2TF5',
						'STAODAZNIS'
					).replace('CH1U0ZGKSI', 'E3GC4QDIZW').replace('sam1_12345', 'STAODAZNIS'),
					'@translations': {
						name: trIcon
					}
				}
			});


			void image;
			void text;
		}
		await super.component_initialize();
	};

	override async component_start(ev: STD.events.Event<any, any>) {
		await super.component_start(ev);
	};

	onValueUpdated() {
		const select = <InputSelect.Component>this.component_find('@.options');
		const option = select.value;
		if (!option) {
			this.component_throwLibraryError('Value updated but there no value!', {select});
		}
		const id = option.id;
		STD.translationsManager.use(id);
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: ILanguageSelectorComponentConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement>STD.DOM.factory({
			tag: 'div'
		});
	};
};
export namespace NS {
	export const Component = LanguageSelectorComponent;
	export type Component = LanguageSelectorComponent;
	export type Configuration = ILanguageSelectorComponentConfiguration;
}
import manifestXMLSource from './LanguageSelector.xml';
import './LanguageSelector.scss';

CM.Manager.declare({
	id: 'language-selector',
	type: LanguageSelectorComponent,
	manifest: manifestXMLSource
});
